import React, { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import PageContainer from '../../../../components/Container/pageContainer'
import { Box, Grid, Tab, Tabs, Typography } from '@mui/material'
import CustomForm from '../../../../components/form/form'
import { Main } from '../../../../constant'
import { CustomBtn } from '../../../../components/button/button'
import SuggestionInput from '../../../../components/suggestionInput/suggestionInput'
import { Date } from '../../../../components/Date/Date'
import dayjs from 'dayjs'
import CustomTable from '../../../../components/table/SimpleTable'
import { Input } from '../../../../components/input/input'
import { useDispatch, useSelector } from 'react-redux'
import axios from 'axios'
import { FullDate } from '../../../../components/Date/FullDate'
import { PostRequest } from '../../../../redux/actions/PostRequest'
import { CustomSelect } from '../../../../components/select/select'
import StudentReportComponent from '../../../../components/report/student'
import { ShowLoader } from '../../../../redux/actions/loader'
import { TabPanel, TabContext } from '@mui/lab';
import ShowClass from '../../Attendance/studentAttendance/components/showClass';
import TransportAddRemove from './transportAddRemove'
import { SelectOnObject } from '../../../../components/select/selectOnObject'

const OtherFee = (props) => {
  const [data, setData] = useState(Main().Fee);
  const [getfilterdata, setGetfilterdata] = useState(data.inputs.filter((item) => item.feildtype !== 'label'));
  const [initialInputValues, setInitialInputValues] = useState(Object.fromEntries(
    getfilterdata
      .map((item) => [item.name, ''])
  ));
  const [currentTab, setCurrentTab] = useState(0); // State variable to control the current tab
  const [suggestions, setSuggestions] = useState();
  const dispatch = useDispatch();
  const userToken = JSON.parse(sessionStorage.getItem('User_Data'))?.token || undefined;
  const url = useSelector((state) => state.Api);
  const [update, setUpdate] = useState(0);
  const [studentOldDetails, setStudentOldDetails] = useState()
  const [detailStudents, setDetailStudents] = useState()
  const [specifiStudent, setSpecifiStudent] = useState()
  const [maxSelectableDate, setMaxSelectableDate] = useState();
  const showlatefee = useSelector((state) => state.Api.showlatefee);
  const [selectFeesType, setSelectFeesType] = useState('')
  const [feesTypes, setFeesTypes] = useState([
    { Srn: 'Card', type: 'Card Fees' },
    { Srn: 'Marksheet', type: 'Duplicate Marksheet' },
    { Srn: 'Mobile', type: 'Mobile App' }
  ]);
  const [showDetails, setShowDetails] = useState(false)

  const handleChangeTab = (event, newValue) => {
    setCurrentTab(newValue);
  };
  const hasFetchedSuggestions = useRef(false); // Add this ref


  const [inputValues, setInputValues] = useState({ Date: dayjs().format('MMMM YYYY'), ...initialInputValues });

  const fetchstudent = (param) => {
    dispatch(ShowLoader('1'))
    axios.get(url.allOtherFees, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${userToken}`,
      },
    })
      .then((res) => {
        if (res.status === 200) {
          const getDetails = res.data.result.filter(item => item.RollNum !== param.RollNum)
          const specificDetails = res.data.result.filter(item => item.RollNum === param.RollNum)
          // console.log(getDetails)
          setSpecifiStudent(specificDetails)
          // //console.log(res.data.result)
          setDetailStudents(getDetails);
          // //console.log(param)
          // setTimeout(()=>{
          dispatch(ShowLoader('0'))
          // },1000)
        }
      })
      .catch((err) => {
        dispatch(ShowLoader('0'))
        //console.error(err); // Log the error response for debugging
      });
  }
  function suggestionhandleInputChange(e) {
    setShowDetails(true)
    setStudentOldDetails('')
    //console.log(e.target.name, e.target.value)
    setInputValues((prevValues) => ({
      ...prevValues,
      [e.target.name]: e.target.value,
      Ammount: '',
    }));
    const RollNum = { RollNum: e.target.value }
    fetchstudent(RollNum)
  }
  const submitfunc = async (e) => {
    e.preventDefault();
  
    // Show loader
    dispatch(ShowLoader('1'));
  
    const payload = {
      Fees: inputValues.Ammount,
      RollNum: inputValues.RollNum,
      FeesType: selectFeesType,
      Comments: inputValues.comments,
    };
  
    //console.log(payload);
  
    try {
      // Make the POST request
      await dispatch(PostRequest(url.otherFees, userToken, payload));
  
      // Fetch student data after the POST request is successful
      await fetchstudent(inputValues.RollNum);
    } catch (err) {
      //console.error(err); // Log the error response for debugging
    } finally {
      // Hide loader regardless of success or failure
      dispatch(ShowLoader('0'));
    }
  };

  const callSuggestions = () => {
    // console.log(hasFetchedSuggestions)
    if (hasFetchedSuggestions.current) return 
    hasFetchedSuggestions.current = true 
    try {
      axios.get(url.studentsuggestion, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${userToken}`,
        },
      })
        .then((res) => {
          if (res.status === 200) {
            //console.log(res.data.message);
            setSuggestions(res.data.message);
          }
        })
        .catch((err) => {
          //console.error(err); // Log the error response for debugging
        });
    } catch (err) {
      //console.error(err);
    }
  }
  useEffect(() => {
     // hasFetchedSuggestions.current = true; // Mark as fetched
    // callSuggestions()
  },[]);

  function handleInputChange(e) {
    setInputValues((prevValues) => ({
      ...prevValues,
      [e.target.name]: e.target.value,
      ['Discount']: studentOldDetails?.FeesDetials?.Discount
    }));
    //console.log(inputValues)
  }

  const ChangeOnSelect = (selectedValue, name) => {
    //console.log("Selected Value:", selectedValue[0]); // Logs the selected value (e.g., '2' for 'two')
    setSelectFeesType(selectedValue[0])
  };

  return (
    <TabContext value={currentTab.toString()}>
      <PageContainer title="Student Attendance">
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={currentTab} onChange={handleChangeTab} aria-label="basic tabs example">
          <Tab label="Transport" value={0} />
          {/* <Tab label="Fees  فیس" value={1} /> */}
          </Tabs>
        </Box>
        <TabPanel value="0">
          <TransportAddRemove />
        </TabPanel>
        <TabPanel value="1">
          <form onSubmit={submitfunc}>
            <Grid container>
              <Grid item lg={6} md={9} sm={12} xs={12}>
                <SuggestionInput
                  handleInputChange={suggestionhandleInputChange}
                  Suggestions={suggestions}
                  placeholder='Roll No / Name'
                  name='RollNum'
                />
                {
                  showDetails ? (
                    <>
                      <Grid container>
                        

                      </Grid>
                      <br />
                      <SelectOnObject
                        items={feesTypes}
                        option="type"
                        name="Fees Types"
                        GetSelectedValue={ChangeOnSelect}
                      />
                      <br />
                      <Input sx={{ margin: '15px 0px 0px' }} onChange={(event) => handleInputChange(event)} name="Ammount" placeholder='Ammount' />
                      <Input sx={{ margin: '15px 0px 0px' }} onChange={(event) => handleInputChange(event)} name="comments" placeholder='Comments' />
                      {/* <br /> */}
                      <Box mt={1}></Box>
                      <CustomBtn disable={(inputValues.Ammount == '' || inputValues.Ammount == undefined) && (selectFeesType != '')} data='Submit' />
                    </>
                  )
                    :
                    null
                }
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                {
                  studentOldDetails && (
                    <StudentReportComponent data={studentOldDetails.StudentDetails} />

                  )
                }
              </Grid>
            </Grid>
          </form>
          <Grid container>
            <Grid item lg={9} mt={4}>
              {
                // studentOldDetails && studentOldDetails.result != [] && studentOldDetails.result != [] ? 
                specifiStudent?.length != 0 && specifiStudent != null && specifiStudent != undefined ?
                  <CustomTable data={specifiStudent} />
                  :
                  null
              }
            </Grid>
            <Grid item lg={9} mt={4}>
              <p>Othere Students</p>
              {
                // studentOldDetails && studentOldDetails.result != [] && studentOldDetails.result != [] ? 
                detailStudents?.length != 0 && detailStudents != null && detailStudents != undefined ?
                  <CustomTable data={detailStudents} />
                  :
                  null
              }
            </Grid>
          </Grid>
        </TabPanel>
      </PageContainer>
    </TabContext>
  );
}

OtherFee.propTypes = {}

export default OtherFee